import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';

import user from 'assets/images/no-avatar.png';
import Dropdown from 'components/dropdown';
import { DropdownItemDefault } from 'components/dropdown/items/default';
import { AppRoutes } from 'config/routes';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { logout } from 'store/thunks/auth/auth';

import { ReactComponent as LogoutIcon } from 'assets/images/logout.svg';
import { ReactComponent as UserIcon } from 'assets/images/user.svg';

import { companyNameFormater } from 'modules/certificates';
import { useGetMyOrganizationsQuery } from 'store/api/organizations';
import { useMeQuery } from 'store/api/profile';
import { selectCurrentCertificateInfo } from 'store/reducers/certificates';
import s from './navbar.module.scss';
import { Organization } from 'store/api/types';

export const User = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { data: me, isFetching } = useMeQuery();
  const { data: myOrganizations, isFetching: isFetchingOrganization } =
    useGetMyOrganizationsQuery();
  const currentOrganization: Organization | undefined = myOrganizations?.[0];

  const userInfo = useSelector(selectCurrentCertificateInfo());
  const [isLogoutModalVisible, setLogoutModalVisible] = useState(false);

  const { Home, Profile, Organizations } = AppRoutes.Dashboard;

  const handleLogout = () => {
    setLogoutModalVisible(true);
  };

  const handleConfirmLogout = () => {
    dispatch(logout());
    setLogoutModalVisible(false);
  };

  const handleCancelLogout = () => {
    setLogoutModalVisible(false);
  };

  const title = useMemo(() => {
    if (isFetching) {
      return t('Loading...');
    }

    if (me?.firstName) {
      return `${me?.firstName} ${me.lastName}`;
    }

    if (userInfo?.['Имя/Отчество']) {
      const onlyName = userInfo?.['Имя/Отчество'].split(' ')[0];
      const surname = userInfo?.['Имя/Отчество'].split(' ')[1];
      if (onlyName && surname) {
        return `${onlyName} ${surname[0]}.`;
      }
    }

    return userInfo?.['Имя/Отчество'] || userInfo?.['Владелец'] || userInfo?.['Компания'];
  }, [isFetching, me, userInfo]);

  const subtitle = useMemo(() => {
    if (isFetchingOrganization) {
      return t('Loading...');
    }

    if (currentOrganization?.name?.length) {
      return currentOrganization.name;
    }

    if (userInfo?.['Компания']) {
      return companyNameFormater(userInfo?.['Компания']);
    }

    return (
      (userInfo?.['Компания'] || userInfo?.['Владелец'] || userInfo?.['Должность']) ??
      userInfo?.['T'] ??
      'Администратор'
    );
  }, [isFetchingOrganization, currentOrganization?.name]);

  return (
    <div className={s.container}>
      <div className={s.info}>
        {/* <Dropdown
          button={
            <div className={s.changeUser}>
              <span className={s.organization}>
                {userInfo?.['Имя/Отчество'] || userInfo?.['Владелец'] || userInfo?.['Компания']}
              </span>

              <ArrowIcon />
            </div>
          }
          footer={
            <Button
              icon={<PlusIcon />}
              className={classesButtonAdd}
              displayType="outlined-primary"
              onClick={() => navigate(Home + Organizations.Home + Organizations.Requisites)}
            >
              {t('Add')}
            </Button>
          }
        >
          <DropdownItemDefault
            onClick={() => {
              navigate(Home + Profile.Home + Profile.PersonalData);
            }}
          >
            <div className={s.item}>
              <span>{userInfo?.['Имя/Отчество'] ?? userInfo?.['Компания']}</span>

              <CheckIcon />
            </div>
          </DropdownItemDefault>
        </Dropdown> */}

        <div className={s.changeUser}>
          <span className={s.organization}>{title}</span>
        </div>

        <span className={s.position}>{subtitle}</span>
      </div>

      <Dropdown button={<img src={user} alt="user" width={40} height={40} />}>
        <DropdownItemDefault
          onClick={() => {
            navigate(Home + Profile.Home + Profile.PersonalData);
          }}
        >
          <div className={s.itemProfile}>
            <UserIcon />
            {t('Profile')}
          </div>
        </DropdownItemDefault>
        {/* <DropdownItemDefault onClick={handleLogout}>
          <div className={s.itemProfile}>
            <RefreshIcon />
            {t('Change user')}
          </div>
        </DropdownItemDefault> */}
        <DropdownItemDefault
          onClick={() => {
            handleLogout();
          }}
        >
          <div className={s.itemProfile}>
            <LogoutIcon />
            {t('Logout')}
          </div>
        </DropdownItemDefault>
      </Dropdown>

      <Modal
        title={t('Confirm Logout')}
        open={isLogoutModalVisible}
        onOk={handleConfirmLogout}
        onCancel={handleCancelLogout}
        okText={t('Logout')}
        cancelText={t('Cancel')}
      >
        {t('Are you sure you want to logout?')}
      </Modal>
    </div>
  );
};
